import axios from "./axiosInstance";
import config from "./config";
import { captureException } from "../utils/sentry";

const BASE_URL = config.BASE_URL;

export interface StripeKillswitchStatus {
  disabled: boolean;
  disabled_at: string | null;
  disabled_by: string | null;
  disabled_by_label: string | null;
  reason: string | null;
}

const authHeaders = (token: string) => ({
  "Content-Type": "application/json",
  authorization: `Bearer ${token}`,
});

export const getStripeKillswitchStatus = (
  token: string,
): Promise<{ success: boolean; data?: StripeKillswitchStatus; error?: string }> =>
  axios
    .get(`${BASE_URL}/stripe-killswitch`, { headers: authHeaders(token) })
    .then((res) => res.data)
    .catch((err) => {
      captureException(err);
      return {
        success: false,
        error: err.response?.data?.error || err.message,
      };
    });

export const setStripeKillswitch = (
  token: string,
  payload: { disabled: boolean; reason?: string },
): Promise<{ success: boolean; data?: StripeKillswitchStatus; error?: string }> =>
  axios
    .post(`${BASE_URL}/stripe-killswitch`, payload, { headers: authHeaders(token) })
    .then((res) => res.data)
    .catch((err) => ({
      success: false,
      error: err.response?.data?.error || err.message,
    }));
